import { create } from "zustand";
import { playNotificationSound } from "utils/playNotificationSound";

// GetCurrentUserNotification list items.
function mapApiNotification(raw) {
  return {
    id: raw?.notificationId,
    notificationFor: raw?.notificationFor,
    bookingId: raw?.bookingId,
    customerId: raw?.customerId,
    notificationSubject: raw?.notificationSubject,
    notificationMessage: raw?.notificationMessage,
    unitName: raw?.unitName,
    isRead: raw?.isRead,
    createdAt: raw?.sentOn,
  };
}

// ReceiveNotification socket payloads come straight off the DB entity
// (int/vc/bt/dt prefixes), unlike the REST list which is already DTO-mapped.
function mapSocketNotification(raw) {
  return {
    id: raw?.intNotificationId,
    notificationFor: raw?.intNotificationFor,
    bookingId: raw?.intBookingId,
    customerId: raw?.intCustomerId,
    notificationSubject: raw?.vcNotificationSubject,
    notificationMessage: raw?.vcNotificationMessage,
    unitName: raw?.vcUnitName,
    isRead: raw?.btIsRead,
    createdAt: raw?.dtCreatedOn,
  };
}

export const useNotificationStore = create((set) => ({
  notifications: [],
  activeToast: null,
  isDrawerOpen: false,

  setNotifications: (notifications) =>
    set({
      notifications: (notifications || [])
        .map(mapApiNotification)
        .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0)),
    }),

  openDrawer: () => set({ isDrawerOpen: true }),
  closeDrawer: () => set({ isDrawerOpen: false }),

  // Drives only the toast/ring — the drawer list and unread count come from
  // their own REST APIs, not this socket push.
  receiveNotification: (payload) => {
    const notification = mapSocketNotification(payload);
    set({ activeToast: notification });
    playNotificationSound();
  },

  dismissToast: () => set({ activeToast: null }),
}));
